module.exports = __webpack_public_path__ + "static/mobile-banner-05932befd5cde059e1099b370b5fc251.png";